import { Navbar } from "flowbite-react";
import { Link } from "react-router-dom";
import { Button } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import HeroSection from "./HeroSection";
import ShowcaseSection from "./ShowcaseSection";
import MensagemQualificadaSection from "./MensagemQualificadaSection";
import ModalPreviewSection from "./ModalPreviewSection";
import DashboardInsightsSection from "./DashboardInsightsSection";
import MelhorQueEcommerceSection from "./MelhorQueEcommerceSection";
import LucasLmirSection from "./LucasLmirSection";
import PlanosSection from "./PlanosSection";
import CTASection from "./CTASection";
import FooterLanding from "./FooterLanding";
import GeradorDeLinksSection from "./GeradorDeLinksSection";
import { registrarVisitaLanding } from "../../api/public";

function getLandingSessionId() {
  const storageKey = "vintree_landing_session_id";
  const existing = window.sessionStorage.getItem(storageKey);
  if (existing) return existing;

  const sessionId =
    window.crypto?.randomUUID?.() ||
    `landing_${Date.now()}_${Math.random().toString(16).slice(2)}`;
  window.sessionStorage.setItem(storageKey, sessionId);
  return sessionId;
}

function getDevice() {
  return window.matchMedia("(max-width: 768px)").matches ? "mobile" : "desktop";
}

function getTrackingPayload(event) {
  const params = new URLSearchParams(window.location.search);
  return {
    event,
    session_id: getLandingSessionId(),
    path: window.location.pathname,
    referrer: document.referrer || null,
    device: getDevice(),
    source: params.get("utm_source") || null,
    medium: params.get("utm_medium") || null,
    campaign: params.get("utm_campaign") || null,
  };
}

const LandingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    registrarVisitaLanding(getTrackingPayload("pageview")).catch(() => {});
    const interval = setInterval(() => {
      registrarVisitaLanding(getTrackingPayload("heartbeat")).catch(() => {});
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="rounded-3xl bg-gradient-to-r from-[#fff1be] via-[#ee87cb] to-[#b060ff] min-h-screen">
      {/* Navbar */}
      <header>
        <Navbar
          fluid
          rounded
          className="fixed inset-x-0 top-0 z-50 shadow-md bg-white"
        >
          <Navbar.Brand href="/">
            <img src="/logo512.png" className="mr-3 h-6 sm:h-9" alt="Vintree" />
            <span className="self-center whitespace-nowrap text-xl text-gray-900 font-semibold">
              Vintree
            </span>
          </Navbar.Brand>
          <div className="lg:flex lg:justify-end">
            <Link to="/entrar" className="text-sm font-semibold text-gray-900">
              Entrar <span aria-hidden="true">&rarr;</span>
            </Link>
          </div>
        </Navbar>
      </header>

      {/* Decorative Background */}
      <div className="relative isolate px-6 lg:px-8">
        <div
          className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>

        {/* Seções */}
        <HeroSection />
        <ShowcaseSection />
        <MensagemQualificadaSection />
        <ModalPreviewSection />
        <DashboardInsightsSection />
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            size="lg"
            pill
            onClick={() => navigate("/cadastrar")}
            className="bg-black text-white hover:bg-gray-800 w-full sm:w-auto"
          >
            Criar minha Vintree grátis
          </Button>
          <Button
            size="lg"
            pill
            gradientDuoTone="pinkToOrange"
            onClick={() => navigate("/loja_exemplo")}
            className="w-full sm:w-auto"
          >
            Ver Vintree de Exemplo
          </Button>
        </div>
        <MelhorQueEcommerceSection />
        <GeradorDeLinksSection />
        <PlanosSection />
        <CTASection />
        <LucasLmirSection />
      </div>
        <FooterLanding />
    </div>
  );
};

export default LandingPage;
